import { UserProfileRequest } from '@oy/types';
import axios, { AUTH_PREFIX, AUTH_PREFIX_V2 } from 'src/clients/axios';
import { UserProfileGetRqData, UserProfileGetRsData } from 'src/models/Client';

export const getProfile = (data?: UserProfileGetRqData) => {
  return axios.get<UserProfileGetRsData>(
    `${AUTH_PREFIX}/account/user-profile`,
    { params: data },
  );
};

export const updateProfile = (data: UserProfileRequest) => {
  return axios.request({
    method: 'POST',
    url: `${AUTH_PREFIX_V2}/account/user-data`,
    data,
  });
};
